<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<a id="title9"></a>
<div class="tp-title"><strong class="b">The Essence of Faith</strong></div>
<div class="tp-subtitle"><strong class="b">Philosophy of Religion</strong></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537399_tp01.vue?12f6de96